module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label> Dodatkowe dane osobowe </label>\n    </dt>\n    <dd>\n        <textarea\n            ng-class=\"IssueFormAdditionalPersonalDataCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"additionalPersonalData\"\n            ng-model=\"IssueFormAdditionalPersonalDataCtrl.additionalPersonalData\"\n        >\n        </textarea>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/additional_personal_data/additional_personal_data.html
// module id = 637
// module chunks = 0